import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import ThankYouIcon from '../img/thankyou.png'; // Import the thank-you icon image

const Confirmation: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Access the tracking number from the navigation state
  const trackingNumber = location.state?.trackingNumber || "N/A";

  const handleGoHome = () => {
    navigate("/"); // Navigate to the homepage or desired page
  };

  return (
    <Box
      sx={{
        padding: 4,
        textAlign: "center",
        backgroundColor: "rgba(255, 255, 255, 0.4)" ,
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        maxWidth: 600,
        margin: "auto",
        borderRadius: 4,
      }}
    >
      {/* Display the Thank You icon */}
          <Box component="img" src={ThankYouIcon} alt="Thank You"
              sx={{ width: 100, height: 100, marginBottom: 2 }} />

      <Typography variant="h5" gutterBottom
      sx={{ fontSize: { xs: "20px", sm: "30px" } }}>
        Thank you for your order with Cozy Bud
      </Typography>
      <Typography variant="h6" sx={{ fontWeight: "bold" }}>
        Tracking Number: {trackingNumber}
      </Typography>
      <Typography variant="h3" sx={{ padding: 1, fontSize: { xs: "0.9rem", sm: "1.0rem", md:"1.3rem"} }}>
        You will receive your items within 3-4 working days.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={handleGoHome}
        sx={{ marginTop: 2, color: "#fff", fontWeight: "600" }}
      >
        Go to Home
      </Button>
    </Box>
  );
};

export default Confirmation;